//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "home",
  data(){
    return{
      isAppBol:false
    }
  },
  mounted(){
    this.getCurrent();
  },
  methods:{
    //  获取当前用户信息
    getCurrent(){
      if(this.$store.state.userType === null){
        this.$get('api/person/current').then((data) => {
          this.$store.dispatch('commitChangeType',data.userType);
          this.$store.dispatch('commitChangeUserId',data.id);
          if(this.$store.state.userType == '1'){
            this.$store.dispatch('commitChangeSupId',null);
          }else{
            this.$get('api/supplier/current-sample').then((res) => {
              this.$store.dispatch('commitChangeSupId',res.id);
            })
          }
        })
      }
    },
    indexOf(str,par){
      if(!str){
        str = '';
      }
      return str.indexOf(par) != -1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/home/home.vue